import { useState } from "react";
import "./StaticPages.css";

const faqs = [
  { q: "How do I top up my game?", a: "Simply search for your game on the home page, select the pack you want, enter your Game User ID and Zone ID, and pay from your wallet balance. The top-up is delivered instantly." },
  { q: "How do I add money to my wallet?", a: "Go to the Wallet page, enter the amount you want to add, and pay via UPI. Your wallet will be credited automatically within seconds." },
  { q: "What payment methods are accepted?", a: "We accept all UPI payment methods including Google Pay, PhonePe, Paytm, BHIM, and any other UPI-enabled app." },
  { q: "How long does delivery take?", a: "Most orders are delivered instantly (within 5-30 seconds). In rare cases, manual orders may take up to 15 minutes during business hours." },
  { q: "What if I entered the wrong User ID?", a: "Please double-check your User ID and Zone ID before placing an order. Once delivered, we cannot reverse the top-up if it was sent to the wrong account. Use the 'Verify Player' button to confirm your details." },
  { q: "Can I get a refund?", a: "If your order failed to deliver due to a system error, you will receive an automatic refund to your wallet. For other cases, contact our support team within 24 hours." },
  { q: "Can I withdraw wallet balance to my bank?", a: "No, wallet balance is non-withdrawable and can only be used for purchases on RinStore." },
  { q: "What is a reseller account?", a: "Reseller accounts get special discounted pricing on all products. Contact us via the Help Center to apply for reseller status." },
  { q: "Is my account secure?", a: "Yes. We use bcrypt password hashing, encrypted payment tokens, rate limiting, and other industry-standard security measures to protect your account." },
  { q: "How do I reset my password?", a: "Click 'Forgot password?' on the login page, enter your email, and follow the link sent to your inbox to set a new password." },
  { q: "Which games are supported?", a: "We support Mobile Legends, PUBG Mobile, Free Fire, Genshin Impact, Honkai Star Rail, Honor of Kings, and many more. Check the home page for the full list." },
  { q: "How do I contact support?", a: "Visit the Help page and send us a message, or email us directly at support@rinstore.in. We typically respond within a few hours." },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);

  return (
    <div className="static-page">
      <h1>Frequently Asked Questions</h1>
      <p className="lead">Find answers to the most common questions about RinStore.</p>

      <div className="faq-list">
        {faqs.map((f, i) => (
          <div key={i} className={`faq-item${open === i ? " open" : ""}`}>
            <button className="faq-q" onClick={() => setOpen(open === i ? null : i)}>
              <span>{f.q}</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
                style={{ transform: open === i ? "rotate(180deg)" : "rotate(0)", transition: "transform .2s" }}>
                <path d="m6 9 6 6 6-6"/>
              </svg>
            </button>
            {open === i && <div className="faq-a"><p>{f.a}</p></div>}
          </div>
        ))}
      </div>

      <section style={{ marginTop: 40 }}>
        <h2>Still have questions?</h2>
        <p>Can't find what you're looking for? <a href="/support">Contact our support team</a> and we'll get back to you as soon as possible.</p>
      </section>
    </div>
  );
}